/**
 * @author omriha
 * 05/02/2020
 */
import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import SMCPage from '../../../components/core/pageComponents/SMCPage';
import {useEditorDimensions} from '../../../utils/hooks';
import SMCEditor from '../../../components/Editor';
import {useSystemSettingsEditor} from './SystemSettingsEditorHelper';
import RouteLeavingGuard from '../../PopupPages/RouteLeavingGuard';
import {isAdminReadOnlySelector} from '../../../store/selectors/user.selectors';
import {SMCDisabledProvider} from '../../../components/Simple/SMCDisabledContext';
import VerifyButtonsContainer from "../VerifyButtonsContainer";

/**
 * High level element to fetch, edit and save system settings, all logic implemented inside.
 */
function SystemSettingsEditor({
    urlParams,
    isAdminReadOnly
}) {
    const { editorWidth, editorHeight } = useEditorDimensions();

    let defaultPage = 'general';
    const queryParams = queryString.parse(urlParams);
    if (queryParams && queryParams['page']) {
        defaultPage = queryParams['page'];
    }

    const {
        systemSettingsObject,
        isObjectDirty,
        editorPages,
        helpId,
        isPageDataLoaded,
        isPageLoadFailed,
        isInnerPageLoading,
        chosenPageId,
        errorMessagesByPageList,
        onPageChange,
        setSystemSettingsData,
        saveButtonOnClick,
        revertButtonOnClick,
        reloadPageData,
        refreshAction,
        systemBackupRunNowAction
    } = useSystemSettingsEditor(defaultPage);
    
    // Data passed down to the editor pages
    const editorPageData = {
        systemSettingsObject,
        setEditorPageId: onPageChange,
        setSystemSettingsData,
        isPageDataLoaded,
        editorWidth,
        editorHeight,
        refreshAction,
        systemBackupRunNowAction
    }

    return (
        <>
        <RouteLeavingGuard when={isObjectDirty} />
        <SMCPage loading={!isPageDataLoaded} helpId={helpId}>
            <div className="ObjectEditor" style={{ width: editorWidth }}>
                <SMCDisabledProvider forceDisable={isAdminReadOnly}>
                    <SMCEditor
                        editorPageData={editorPageData}
                        height={editorHeight}
                        width={editorWidth}
                        errorListByPage={errorMessagesByPageList}
                        chosenPageId={chosenPageId}
                        onPageChange={onPageChange}
                        isPageLoaded={isPageDataLoaded && !isInnerPageLoading}
                        isPageLoadFailed={isPageLoadFailed}
                        reloadData={reloadPageData}
                        pages={editorPages}
                    />
                </SMCDisabledProvider>
            </div>
        </SMCPage>
            <VerifyButtonsContainer
                disabled={!isPageDataLoaded || isAdminReadOnly}
                onClickSaveButton={saveButtonOnClick}
                onClickCancelButton={revertButtonOnClick}
            />
        </>
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
    isAdminReadOnly: isAdminReadOnlySelector(state)
});

const mapDispatchToProps = null;

export default connect(mapStateToProps, mapDispatchToProps)(SystemSettingsEditor);